module.exports = __webpack_public_path__ + "static/media/index.65d1b90c.md";